import * as Enumerable from 'linq';
import { AttributeFilter } from '../../entity';
import { Contact } from '../../contact/contact';


export class ContactIndexUtility {

    public static getAttributeFilter(contact: Contact): AttributeFilter[] {

        const filters: AttributeFilter[] = [];;

        filters.push({ k: 'active', v: !!contact?.active });

        if (contact?.type)
            filters.push({ k: 'type', v: contact?.type });

        const safeParents = Enumerable.from(contact?.parents)?.where(x => !!x?._id).toArray();
        const safeLabels = Enumerable.from(contact?.labels)?.where(x => !!x?._id).toArray();
        const safeWorkCategories = Enumerable.from(contact?.workCategories)?.where(x => !!x?._id).toArray();
        const safeZones = Enumerable.from(contact?.zones)?.where(x => !!x?._id).toArray();

        if (safeParents?.length)
            filters.push(...safeParents.map(p => ({ k: 'parent', v: p?._id, n: p?.name })));

        if (safeLabels?.length)
            filters.push(...safeLabels?.map(label => ({ k: 'tags', v: label?._id, n: label?.name })));

        if (safeWorkCategories?.length)
            filters.push(...safeWorkCategories?.map(label => ({ k: 'workCategories', v: label?._id, n: label?.name })));

        if (safeZones?.length)
            filters.push(...safeZones?.map(label => ({ k: 'zones', v: label?._id, n: label?.name })));

        const text = [
            contact.name?.trim() ?? null,
            contact.legalName?.trim() ?? null,
            contact?.phone?.trim().replace(' ', '') ?? null,
            contact?.workPhone?.trim().replace(' ', '') ?? null,
            contact?.mobile?.trim().replace(' ', '') ?? null,
            contact?.email?.trim() ?? null,
        ]
            .filter(x => !!x?.length)
            .map(x => x?.toLowerCase()?.split(' '))
            .filter(x => !!x?.length)
            .flat() as string[];

        if (text?.length)
            filters.push({ k: 'text', v: text });

        return Enumerable
            .from(filters)
            .where(x => x.v !== undefined && x.v !== null && x.v !== '')
            .distinct(x => `${x.k}:${x.v}`)
            .toArray();

    }

}